import axios from "axios";
import { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";
import YoutubeIntegration from "./YoutubeIntegration";

interface VideoLink {
    url: string;
    name: string;
    createdAt: string;
    updatedAt: string;
}

const containerAll = document.querySelector('[data-id=container]');
if (!containerAll) throw new Error('Container element not found');
const root = createRoot(containerAll);

root.render(<YouTube />);


function YouTube() {
    const apiUrl = import.meta.env.VITE_API_URL || 'https://localhost';
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<boolean>(false);

    const [videoLinks, setVideoLinks] = useState<VideoLink[]>([]);

    useEffect(() => {
        const fetchVideos = async () => {
            try {
                const data: VideoLink[] = (await axios.get(`${apiUrl}/api/media/youtube-videos`, {
                    params: {
                        limit: 5,
                    },
                })).data;

                setVideoLinks(data
                    .toSorted((a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                );
            }
            catch (error: any) {
                setError(true);
            }
            finally {
                setLoading(false);
            }
        };

        fetchVideos();
    }, []);

    if (loading) {
        return <p className="text-informative loading">Chargement</p>;
    }

    if (error) {
        return <p className="text-informative error">Une erreur est survenue pendant le chargement. Veuillez réessayer plus tard.</p>;
    }

    if (videoLinks.length === 0) {
        return <p className="italic text-gray-600">Aucune vidéo publiée pour le moment.</p>;
    }

    return (
        <div className="flex flex-wrap justify-center items-center gap-6">
            {
                videoLinks.map((link, index) => {
                    return <div className="py-2 px-4" key={index}>
                        <h3 className="mb-2">{link.name}</h3>
                        <YoutubeIntegration url={link.url} />
                    </div>;
                })
            }
        </div>
    );
}